
import { computed, useContext, useRoute } from '@nuxtjs/composition-api';
import once from 'lodash/once';
import useSelectorSteps from '~/composable/useSelectorSteps';
import { getPlayMixQueryParams } from '~/utils/playMixQuery';

export default {
  props: {
    numberOfSteps: {
      type: Number,
      default: 1
    }
  },
  setup(_props, { emit }) {
    const route = useRoute()
    const subscriptionId = route.value.params.subscriptionid
    const channelSplit = route.value.query.channelsplit
    const { app } = useContext()
    const {
      routers,
      subscription,
      model,
      addToBasketBtnClicked,
      selectedRouterSku,
      isLoanModem,
      setStep
    } = useSelectorSteps(app)

    const getSubscriptionPrice = (prices) => {
      return prices === null ? 0 : prices.find(price => price.channelKey === subscriptionId).priceInKR
    }

    const routerSelected = async (sku) => {
      selectedRouterSku.value = sku
      await addToCart()
    }

    const addToCart = async () => {
      const { partnerAddons: selectedPartnerAddons } = getPlayMixQueryParams(route.value.query)
      const res = await addToBasketBtnClicked({ channelSplit, subscriptionId, selectedPartnerAddons })
      if (res?.cartItemGroupList) {
        emit('subscriptionAddedToBasket', res)
      }
    }

    const backToPlay = () => {
      setStep(1)
    }

    const addSimToRouterList = once((routerList) => {
      if (routerList === null) {
        routerList = []
      }
      routerList.push({
        sku: null,
        productContent: {
          uniqueSellingPoints: [
            'Til dig, der allerede har en router',
            'Eller fx til din tablet'
          ],
          productImages: [{
            imageUrl: '',
            title: 'sim-card',
            altText: 'sim-card'
          }]
        },
        prices: null,
        name: 'SIM-kort'
      })
      return routerList
    })

    const routerListWithSimOnly = computed(() => {
      const routerList = routers.value ? [...routers.value] : []
      return addSimToRouterList(routerList)
    })
    return {
      backToPlay,
      addToCart,
      isLoanModem,
      addToBasketBtnClicked,
      routers,
      subscription,
      model,
      routerListWithSimOnly,
      selectedRouterSku,
      routerSelected,
      getSubscriptionPrice,
      channelSplit
    }
  }
}
